import { useEffect, useState } from 'react';
import { api, type PlanSegment } from '../lib/api';

// The live reads the door (T206): who asked to be told when this goes live,
// and the questions viewers asked on rookeryos.com that no episode answers —
// each one a segment away from tonight's run of show.
export function LiveFromTheDoor({ reminders, plan, onAddSegment }: { reminders: number; plan: PlanSegment[]; onAddSegment: (segment: PlanSegment) => void | Promise<void> }) {
  const [questions, setQuestions] = useState<{ question: string; hits: number }[]>([]);
  useEffect(() => { api.doorQuestions().then((qs) => setQuestions(qs.filter((q) => !q.answerable).slice(0, 8).map((q) => ({ question: q.question, hits: q.hits })))).catch(() => setQuestions([])); }, []);
  if (reminders === 0 && questions.length === 0) return null;
  const inPlan = (q: string) => plan.some((s) => (s.note ?? '').toLowerCase().includes(q.toLowerCase().slice(0, 40)));
  return (
    <div data-tool="live-from-the-door" style={{ border: '1px solid var(--line)', borderRadius: 8, padding: '6px 10px', marginBottom: 10 }}>
      <div style={{ fontWeight: 600 }}>From the door</div>
      {reminders > 0 && <p className="sub-dim" style={{ margin: '2px 0 0' }} data-tool="live-reminders">{reminders} viewer{reminders === 1 ? '' : 's'} asked to be told when you go live — they hear by email at On air.</p>}
      {questions.length > 0 && (
        <>
          <p className="sub-dim" style={{ margin: '6px 0 2px' }}>Questions viewers asked on rookeryos.com that no episode answers — answer one tonight:</p>
          <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 3 }}>
            {questions.map((q) => (
              <li key={q.question} style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 13 }}>
                <span style={{ flex: 1, minWidth: 0 }}>{q.question} {q.hits > 1 && <span className="chip">{q.hits}×</span>}</span>
                {inPlan(q.question) ? <span className="chip">in the run of show</span>
                  : <button type="button" className="btn tiny" title="Add a five-minute segment with this question as its note" onClick={() => void onAddSegment({ title: q.question.length > 60 ? q.question.slice(0, 57) + '…' : q.question, minutes: 5, note: `From the door: ${q.question}`.slice(0, 200) })}>+ segment</button>}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
